import axios from 'axios';

const instance = axios.create({withCredentials: true, baseURL: process.env.NEXT_PUBLIC_API_BASE_URL});

const attachTokenInterceptor = (token, fetchToken) => {
    instance.interceptors.request.use(
        async (config) => {
            if (!token || isTokenExpired(token)) {
                try {
                    await fetchToken();
                    token = localStorage.getItem('token');
                    console.log('fetched token', token);
                } catch (error) {
                    clearServiceToken(); // Clear the token if fetching failed
                    return Promise.reject('Failed to retrieve token');
                }
            }

            if (token) {
                config.headers['Authorization'] = 'Bearer ' + token;
            }

            return config;
        },
        (error) => {
            console.error(error);
            return Promise.reject(error);
        }
    );
};

instance.interceptors.response.use(
    (response) => {
        console.log('Received headers:', response.headers);
        if (response.headers['new-token']) {
            localStorage.setItem('token', response.headers['new-token']);
        } else if (response.headers['token']) {
            localStorage.setItem('token', response.headers['token']);
        } else if (response.headers['token-invalid']) {
            clearServiceToken();
        }
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            clearServiceToken();
        } else if (error.code === "ERR_NETWORK") {
            if (window.location.pathname !== '/server-outage') {
                window.location.replace('/server-outage');
            }
        }
        return Promise.reject(error);
    }
);

const isTokenExpired = (token) => {
    try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        return decoded.exp < Date.now() / 1000;
    } catch (e) {
        return true;
    }
};

const clearServiceToken = () => {
    console.debug('Clearing service tokens');
    localStorage.removeItem('token');
    localStorage.removeItem('userObj');
    delete axios.defaults.headers.common.Authorization;
};

export {attachTokenInterceptor, clearServiceToken};
export default instance;
